<template>
    <div>
        <h2>Signatures</h2>
        <div class="flex">
            <button v-on:click.stop="showRecordSignatureModal = true">Record signature</button>
        </div>
        <table>
            <thead>
                <tr>
                    <th>Document</th>
                    <th>Version</th>
                    <th>Signed by</th>
                    <th>Signed at</th>
                </tr>
            </thead>
            <tbody v-if="loading">
                <tr>
                    <td colspan="8" class="LoadingCell">
                        <loading-indicator /> Loading
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr v-for="row in signatures" :key="row.roleDocumentSignatureId">
                    <td>
                        {{row.documentType}}
                    </td>
                    <td>
                        {{row.version}}
                    </td>
                    <td>
                        {{row.name}}
                    </td>
                    <td>
                        {{row.timeStamp}}
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="modalBackground" v-if="showRecordSignatureModal">
            <div class="ModalForm">
                <div class="header">
                    <h2>Record signature</h2>
                </div>
                <div class="modalContent">
                    <label>Document: <input type="text" v-model="document" /></label>
                    <label>Version: <input type="text" v-model="version" /></label>
                    <label>Signed by: <input type="text" v-model="name" /></label>
                    <label>Signed at: <input type="datetime-local" v-model="timeStamp" /></label>
                </div>
                <div class="modalActions">
                    <button v-on:click.stop="showRecordSignatureModal = false">Cancel</button>
                    <button v-on:click.stop="recordSignature()">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .flex {
        display: flex;
    }

    table {
        margin-top: 16px;
    }

    label {
        width: 400px;
        max-width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
    }

        label span {
            font-weight: bold;
        }

        label input {
            width: 150px;
        }

    .ModalForm {
        height: auto;
        width: 400px;
        top: 50px;
    }

    .header {
        padding: 15px;
    }

    .modalContent {
        padding: 15px;
    }

    .modalActions {
        display: flex;
        justify-content: end;
        padding: 15px;
    }

    h4, h2 {
        margin: 0;
    }

    .root {
        margin: 16px 0;
    }

    button:not(:first-of-type) {
        margin-left: 10px;
    }
</style>

<script>
    import $ from 'jquery';
    import LoadingIndicator from './LoadingIndicator.vue';

    const defaultSignature = {
        document: null,
        version: null,
        name: null,
        timeStamp: new Date().toISOString().slice(0, 16),
    };

    export default {
        name: 'RoleSignatures',
        components: {
            LoadingIndicator,
        },
        data: function () {
            return {
                signatures: [],
                showRecordSignatureModal: false,
                document: defaultSignature.document,
                version: defaultSignature.version,
                name: defaultSignature.name,
                timeStamp: defaultSignature.timeStamp,
                loading: false,
            };
        },
        props: ['roleId'],
        mounted: function () {
            var myComponent = this;
            myComponent.loading = true;
            $.ajax({
                type: 'GET',
                url: `Signature/ListRoleSignatures/${this.roleId}`,
                contentType: 'application/json',
            }).then(signatures => {
                myComponent.signatures = signatures;
                myComponent.loading = false;
            }, () => {
                alert('An error occurred while loading the signatures');
                myComponent.loading = false;
            });
        },
        methods: {
            recordSignature: function () {
                var thisComponent = this;
                thisComponent.loading = true;
                $.ajax({
                    type: 'POST',
                    url: `Signature/RecordRoleSignature/${thisComponent.roleId}`,
                    data: JSON.stringify({
                        documentType: thisComponent.document,
                        name: thisComponent.name,
                        version: thisComponent.version,
                        timeStamp: thisComponent.timeStamp,
                    }),
                    contentType: 'application/json',
                }).then(newSignature => {
                    thisComponent.signatures.push(newSignature);

                    thisComponent.document = defaultSignature.document;
                    thisComponent.version = defaultSignature.version;
                    thisComponent.name = defaultSignature.name;
                    thisComponent.timeStamp = defaultSignature.timeStamp;

                    thisComponent.showRecordSignatureModal = false;

                    thisComponent.loading = false;

                }, function () {
                    alert(`An error occurred while saving the signature record`);
                    thisComponent.loading = false;
                });
            }
        }
    }
</script>